const ITEMS = [
  "Glass repairs",
  "Handyman work",
  "Garden maintenance",
  "Southern Adelaide",
  "One call sorts it",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center font-display text-lg font-semibold uppercase tracking-[0.25em] md:text-xl">
        <span className="px-6">{item}</span>
        <span aria-hidden="true" className="text-navy/50">
          //
        </span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="marquee-band"
    aria-hidden="true"
    className="relative z-10 -mx-2 -my-4 -rotate-[1.2deg] overflow-hidden bg-orange py-4 text-navy"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
